import type { DraftNode } from "../types";

export function getItemAtPath(items: DraftNode[], path: number[]): DraftNode | undefined {
  const [head, ...rest] = path;
  const item = items[head];
  if (!item) return undefined;
  if (rest.length === 0) return item;
  return "items" in item ? getItemAtPath(item.items, rest) : undefined;
}
export function updateItemAtPath(items: DraftNode[], path: number[], updates: Partial<DraftNode>): DraftNode[] {
  const [head, ...rest] = path;
  return items.map((item, index) => {
    if (index !== head) return item;
    if (rest.length === 0) return { ...item, ...updates } as DraftNode;
    return "items" in item ? ({ ...item, items: updateItemAtPath(item.items, rest, updates) } as DraftNode) : item;
  });
}
export function removeItemAtPath(items: DraftNode[], path: number[]): DraftNode[] {
  const [head, ...rest] = path;
  if (rest.length === 0) return items.filter((_, index) => index !== head);
  return items.map((item, index) =>
    index === head && "items" in item ? ({ ...item, items: removeItemAtPath(item.items, rest) } as DraftNode) : item,
  );
}
export function insertItemAtPath(items: DraftNode[], parentPath: number[], newItem: DraftNode): DraftNode[] {
  if (parentPath.length === 0) return [...items, newItem];
  const [head, ...rest] = parentPath;
  return items.map((item, index) => {
    if (index !== head || !("items" in item)) return item;
    return {
      ...item,
      items: rest.length === 0 ? [...item.items, newItem] : insertItemAtPath(item.items, rest, newItem),
    } as DraftNode;
  });
}
export function moveItemInList(items: DraftNode[], fromIndex: number, toIndex: number): DraftNode[] {
  const result = [...items];
  const [moved] = result.splice(fromIndex, 1);
  if (moved) result.splice(toIndex, 0, moved);
  return result;
}
